/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popPrompt.vue?vue&type=template&id=2919b7d7"
import script from "./popPrompt.vue?vue&type=script&lang=js"
export * from "./popPrompt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports